export default function(time) {
  return new Promise(function(resolve) {
    window.setTimeout(resolve, time);
  });
}



// WEBPACK FOOTER //
// ./src/shared/utils/src/timeout.js